<template>
  <div class="headerbar-container">
    <div class="name" @click="goHome()">Simply Studio</div>
    <div v-if="isAuthenticated" class="user" @click="gotoSettings()">
      Hello<span v-if="user.given_name">, {{ user.given_name }}</span>
      <div class="avatar">
        <img :src="user.picture"/>
      </div>
      <div class="logout" @click="logout">Logout</div>
    </div>
  </div>
</template>

<script>
import authService from '@/services/authentication-service.js'
export default {
  name: 'Headerbar',
  data() {
    return {
      key: "value"
    }
  },
  methods: {
    logout() {
      authService.logout()
    },
    goHome() {
      if(this.isAuthenticated) {
        this.$router.push('/').catch(error => {
          if (error.name != "NavigationDuplicated") {
            throw error
          }
        })
      }
    },
    gotoSettings() {
      if(this.isAuthenticated) {
        this.$router.push('/settings').catch(error => {
          if (error.name != "NavigationDuplicated") {
            throw error
          }
        })
      }
    }
  },
  computed: {
    isAuthenticated() {
      return this.$store.getters.isAuthenticated
    },
    user() {
      return this.$store.getters.user || {}
    }
  }
}
</script>

<style lang="scss" scoped>
@import '@/assets/shared.scss';

.headerbar-container {
  padding: 20px 100px;
  border-bottom: 1px solid $separator;
  display: flex;
  overflow: hidden;
  position: relative;

  div {
    flex: 1;
    height: 50px; 
    line-height: 50px;
  }
}
.name {
  text-align: left;
  font-size: 24px;
  font-weight: 500;
}
.user {
  text-align: right;
  position: relative;
  cursor: pointer;

  .avatar {
    margin-left: 10px;
    display: inline-block;
    position: relative;
    top: 8px;

    img {
      border-radius: 50%;
      max-width: 30px;
      max-height: 30px;
    }
  }

  .logout {
    display: inline-block;
    font-weight: 500;
    margin-left: 50px;
    cursor: pointer;
  }
}

@media screen and (max-width: 600px) {
  .headerbar-container {
    padding: 20px 40px;

    .name {
      text-align: center;
    }
  }
  .user {
    display: none;
  }
}
</style>